import { Pipe, PipeTransform } from '@angular/core';
import { ProductModel } from '../models/product.model';
import { MathService } from '../services/math/math.service';

@Pipe({ name: 'sumUpBasket',pure:false })
export class SumUpBasketPipe implements PipeTransform {
  constructor(private mathService:MathService){

  }
  transform(products: ProductModel[]) {
    return this.mathService.sumProducts(products);
  }
}